export const GoTerminateSearchDialogMessage = {
    modalTitle: 'Terminate Search',
    modalContent: 'Terminate current Cevo Go search, and start a new one?',
    primaryActionTitle: 'Yes',
    successfulAlertMessage:
        'Application information has been successfully deleted.',
} as const;
